import { createSlice } from "@reduxjs/toolkit";
const initialState = [];

const userSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        addCart(state, action) {
            return [...state, action.payload]
        },
        removeCart(state, action) {
            return state.filter((item) => item.id !== action.payload.id);
        },
        updateCart(state, action) {
            const { id, name } = action.payload;
            console.log(id, name);
            return state.map((item) => item.id === id ? { ...item, title: name } : item);
        }
    }
});


export default userSlice.reducer;
export const { addCart, removeCart, updateCart } = userSlice.actions;